<template>
  <el-dialog
    title="行业设置"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >

    <el-form
            ref="form"
            :model="form"
            label-width="100px"
            size="small"
    >
      <el-form-item
              label="当前行业"
      >
        {{deposit_type}}
      </el-form-item>
      <el-form-item
              label="选择行业"
      >
        <el-radio v-model="form.industry" label="超市">超市</el-radio>
        <el-radio v-model="form.industry" label="自助点餐">自助点餐</el-radio>
        <el-radio v-model="form.industry" label="医药">医药</el-radio>
        <el-radio v-model="form.industry" label="加油站">加油站</el-radio>
        <el-radio v-model="form.industry" label="景区">景区</el-radio>
        <el-radio v-model="form.industry" label="酒店">酒店</el-radio>
      </el-form-item>
      <el-form-item>
      <el-button
              type="primary"
              :loading="loading"
              @click="saveUser"
      >保存</el-button>
      <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<style>

  .bg-purple-dark {
    background: #e5e9f2;
  }
</style>
<script>
import * as agentService from '@/api/sys/agent'
import * as userService from '@/api/sys/user'
import util from '@/libs/util.js'
export default {
  name: 'payconfigureEditForm',
  props: {
    agent: Object,
    accuseVisible: Boolean,
    value: Boolean
  },
  data () {
    return {
      accuseVisible2: true,
      loading: false,
      deposit_type: '',
      dialogVisible: false,
      form: {
        industry: '超市'
      }
    }
  },
  watch: {
    value (val) {
      this.dialogVisible = val
    },
    accuseVisible (newValue, oldValue) {
      console.log('-----' + newValue)
      this.accuseVisible2 = newValue
    },
    handleClick () {

    },
    dialogVisible (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    dialogOpen () {
      this.$refs.form.resetFields()
      this.deposit_type = this.agent.industry
    },
    saveUser () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loading = true
          agentService.saveAgentStore({ ...this.form, id: this.agent.id })
            .then(data => {
              this.loading = false
              this.dialogVisible = false
              this.$emit('submit')
            })
        } else {
          return false
        }
      })
    },
    close () {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>
